import styled from "styled-components";

export const MarketingUL = styled.ul`
    padding-left: 40px;
    list-style-type: disc;
    margin-bottom: 15px;
`;